import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import Image from "../image";
import { Link } from "../../utils/customLink";

const Participants = ({ reviewTitle, reviewSubTitle, reviewBlocks }) => {
  const breakpoint = useBreakpoint();

  return (
    <div className="participants-component dark:bg-gray-dark bg-transparent pt-10 sm:py-8">
      <section
        className="flex flex-col px-4 py-2 sm:py-16 mx-auto md:px-0 md:pt-0 w-full"
        style={{ gridArea: "1/1" }}
      >
        <div className="container flex flex-col w-full md:w-9/12 md:gap-4">
          <h2 className="w-full py-4 font-alice text-[26px] sm:text-[38px] dark:font-body text-black-lighter ">
            {reviewTitle}
          </h2>
          <div
            className="font-normal font-base text-black-lighter  dark:text-gray-generic"
            dangerouslySetInnerHTML={{
              __html: reviewSubTitle
            }}
          />
          <div className="flex w-full py-6">
            <div className="grid grid-cols-1 gap-1 sm:gap-6 md:grid-cols-5 relative">
              <div className="absolute w-1/4 bg-gradient-to-r left-0 from-white dark:from-gray-dark h-full z-10 sm:hidden"></div>
              <div className="absolute w-1/4 bg-gradient-to-l right-0  from-white dark:from-gray-dark h-full z-10 sm:hidden"></div>
              <ConditionalSwiper
                condition={breakpoint === "xs"}
                slidesPerView={2.3}
                spaceBetween={24}
                centeredSlides={true}
                navigation={true}
                pagination={{
                  clickable: true
                }}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                speed={1300}
                className="w-full h-full partners-swiper !pb-8 sm:!pb-0"
              >
                {reviewBlocks?.map((block, i) => {
                  return (
                    <Link
                      className=""
                      to={block.link}
                      key={`participant-link${i}`}
                      target="_gviblank"
                    >
                      <div
                        className="flex items-center justify-center py-2"
                        key={`participant-${i}`}
                      >
                        <div className="pr-2">
                          <Image
                            imageAlt={block.site}
                            image={""}
                            imageClass="object-contain object-center w-8 h-8 grayscale hover:grayscale-0"
                            sourceUrl={block.logo}
                          />
                        </div>
                        <div className="flex flex-col">
                          <div
                            className="text-black-lighter dark:text-gray-generic text-sm"
                            dangerouslySetInnerHTML={{ __html: block.site }}
                          />
                          <div
                            className="text-black-lighter dark:text-gray-generic text-sm"
                            dangerouslySetInnerHTML={{
                              __html: block.count
                            }}
                          />
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </ConditionalSwiper>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Participants;
